module.exports = __webpack_public_path__ + "static/media/ne-NP.9c1b7d33.md";